/** The wizard's entry points (2.J deliverable 9): the sidebar link and the Settings button. */
import { Button } from '@codex/ui';
import { useLocation } from '@tanstack/react-router';
import { NavLink } from '../shell/nav-link.js';
import { useGoTo } from '../shell/open-doc.js';
import { TITLE, useBootstrapEnabled } from './wizard.js';

export const BOOTSTRAP_HREF = '/bootstrap';

/** Nothing is drawn with `flag:sessions` off; the router is read only once it is on. */
export function SidebarBootstrapEntry() {
  return useBootstrapEnabled() ? <SidebarLink /> : null;
}

function SidebarLink() {
  const pathname = useLocation({ select: (location) => location.pathname });
  return (
    <section className="cx-nav-section" aria-label="Bootstrap">
      <ul className="cx-nav-section__list">
        <li className="cx-nav-row-item">
          <NavLink href={BOOTSTRAP_HREF} icon="stack" active={pathname === BOOTSTRAP_HREF}>
            {TITLE}
          </NavLink>
        </li>
      </ul>
    </section>
  );
}

export function SettingsBootstrapSection() {
  return useBootstrapEnabled() ? <SettingsSection /> : null;
}

function SettingsSection() {
  const goTo = useGoTo();
  return (
    <section aria-labelledby="settings-bootstrap" className="cx-settings__bootstrap">
      <h2 id="settings-bootstrap">{TITLE}</h2>
      <p>
        Tell Codex about the sessions you played before it existed. Nothing is written until you
        press Apply.
      </p>
      <Button icon="stack" onClick={() => goTo(BOOTSTRAP_HREF)}>
        {TITLE}
      </Button>
    </section>
  );
}
